import React, { useState, useRef, useEffect } from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";

const OfferCard = ({ lead_id }) => {
  const [params] = useSearchParams();

  const offer = {
    lender_name: "KreditBee",
    credit_limit: "5 Lakhs",
    interest_rate: "12-28.5%",
    processing_fee: "5.10%",
    apr: "29-50%",
    penal_charges: "4%",
    tenure: 48,
    app_url: "#",
    kfs_doc:
      "https://lenders-kfs.s3.ap-south-1.amazonaws.com/kreditbee.pdf",
    logo: "https://campaigns.digitmoney.in/image/KreditBee.png",
    lead_id: lead_id || "No User ID found", // dynamic user id
  };

  useEffect(() => {
    setUserClickData({
      event_name: "offer-pageview-scrubbed-old-kreditbee",
      user_id: lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
  }, []);

  const handleClick = () => {
    setUserClickData({
      event_name: `offer-apply-button-scrubbed-old-kreditbee`,
      user_id: lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });

    fetch("https://core-api.digitmoney.in/api/v1/lead/bulk-lead-push-by-leadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks",
      },
      body: JSON.stringify({
        leads: [{ lead_id: lead_id }],
        lender_name: "KreditBee",
        lender_id: "662752eb65fdba1a48d6e466",
      }),
    }).catch((err) => console.error("API call failed", err));

    window.location.href = "https://kredt.be/home";
  };

  return (
    <div className="offer-card-section">
      <div className="offer-card expanded">
        
        <img src={offer.logo} className="lender-logo" alt="KreditBee" />

        <div className="offer-details">
          <hr className="offer-divider" />

          <div className="amount-row">
            <span className="amount-label1">Max Loan Amount:</span>
            <span className="amount-value">
              upto ₹{offer.credit_limit}
            </span>
          </div>

          <hr className="offer-divider" />

          <div className="emi-row">
            Tenure: {offer.tenure} Months
          </div>

          <hr className="offer-divider" />

          <div className="emi-row">
            Interest Rate: {offer.interest_rate}
          </div>

          <hr className="offer-divider" />

          <div className="w-full text-center pb-2">
            <span className="emi-row">
              Processing Fees: {offer.processing_fee}
            </span>
          </div>

          <hr className="offer-divider" />

          <div className="loan-extra-details mt-3 text-sm text-gray-700">
            <div className="flex justify-between mb-1 font-semibold">
              <span>APR:</span>
              <span>{offer.apr}</span>
            </div>

            <div className="flex justify-between mb-1 font-semibold">
              <span>Penal Charges:</span>
              <span>{offer.penal_charges}</span>
            </div>

            <div className="flex items-center justify-between mt-2 font-semibold">
              <span>View KFS:</span>
              <a
                href={offer.kfs_doc}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-green-700 hover:underline"
              >
                <FileText className="w-4 h-4 mr-1" />
                Document
              </a>
            </div>
          </div>

          <button
            className="get-offer-btn tracking-get-offer-btn-v5"
            onClick={handleClick}
          >
            Get Offer
            <img
              src="/assets/img/Get offer CTA icon.svg"
              alt="Arrow"
              className="cta-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
